import { SubmitHandler, useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import LoginImage from '@/modules/Auth/assets/icons/loginIcon.svg?react';
import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import useSignInRequest from '@/modules/Auth/hooks/useSignInRequest.ts';
import { AUTH_LINKS } from '@/modules/Auth/AUTH_LINKS.ts';
import { Box, Center } from 'styled-system/jsx';
import { css } from 'styled-system/css';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput.tsx';
import FixToBottom from '@/common/components/layouts/FixToBottom.tsx';
import LoadingButton from '@/common/components/base/button/loadingButton.tsx';
import { LoginFormDataType } from '@/modules/Auth/types/formDataType/loginFormData.type.ts';
import NotRegisteredModal from '@/modules/Auth/components/modals/NotRegisteredModal.tsx';
import useModal from '@/common/hooks/useModal.ts';
import useToast from '@/common/store/alert/useToast.ts';

export default function () {
  return (
    <MainLayout title="ورود" header="onlyBackHeader">
      <Login />
    </MainLayout>
  );
}
const Login = () => {
  const { handleSubmit } = useFormContext<LoginFormDataType>();
  const { mutate, isPending } = useSignInRequest();
  const navigate = useNavigate();
  const showAlert = useToast((state) => state.showAlert);
  const { open, openModal, closeModal } = useModal();

  const handleError = (error?: string, faError?: string | null) => {
    if (error === 'adjuster_account_unactivated') {
      openModal();
    } else if (faError) {
      showAlert({
        description: faError,
        type: 'error',
      });
    }
  };
  const onSubmit: SubmitHandler<LoginFormDataType> = ({ phone_number }) => {
    mutate(
      { phone_number },
      {
        onSuccess: () => {
          navigate(AUTH_LINKS.otp);
        },
        onError: (error) => {
          handleError(error.code, error.fa_details);
        },
      },
    );
  };

  return (
    <Box>
      <Center my="20px">
        <LoginImage />
      </Center>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={css({ width: '100%' })}
      >
        <TitleDescription mb="25px" textStyle="b1" color="black-1">
          شماره تماس خود را وارد کنید تا کد تایید برایتان ارسال شود.
        </TitleDescription>
        <MobileInput name="phone_number" />
        <FixToBottom>
          <LoadingButton fullWidth loading={isPending}>
            دریافت کد
          </LoadingButton>
        </FixToBottom>
      </form>
      <NotRegisteredModal open={open} closeModal={closeModal} />
    </Box>
  );
};
